import React from "react";
// import "./../Assets/css/utility.css";

export const OrderNotification = ({
  newOrderPopup,
  setShowRightSide,
  handleRoomObj,
}) => {
  const handleRightSide = (room) => {
    console.log("OrderNotification: handleRightSide called with room:", room);
    setShowRightSide(true);
    // Pass the full room object instead of just ID
    if (room && room.id) {
      handleRoomObj(room.id, room); // Pass both ID and full room object
    } else {
      handleRoomObj(room?.id || room); // Fallback to ID only
    }
  };

  const bgColor = (id) => {
    let bg;

    if (id === 1) {
      bg = "red";
    } else if (id === 2) {
      bg = "#90EE90";
    } else if (id === 3) {
      bg = "#00FF00";
    } else {
      bg = "lightblue";
    }

    return bg;
  };
  return (
    <div className="NewOrderList">
      <h5
        className={`mb-2 ${newOrderPopup.length > 0 ? "text-danger" : ""}`}
        style={{ marginLeft: "-15px" }}
      >
        Order Notification
      </h5>
      <div className="row">
        {newOrderPopup.map((item) => (
          <div
            className="list col-lg-1 col-md-1 col-sm-3"
            style={{ backgroundColor: `${bgColor(item?.status_id)}` }}
            key={item.id}
            onClick={() => handleRightSide(item?.room)}
          >
            <h6> {item?.room?.name}</h6>
          </div>
        ))}
      </div>
    </div>
  );
};
